import { useTranslation } from 'react-i18next';

import { BiometricDataView } from '@/features/biometric/components/BiometricDataView';
import { useCan } from '@/features/roles/hooks/use-can';
import { useRequirePermission } from '@/shared/hooks/useRequirePermission';

export function BiometricDataPage() {
  const { t } = useTranslation('admin');
  const canRead = useRequirePermission('METADATA', 'READ');
  const canWrite = useCan('METADATA', 'WRITE');

  if (!canRead) return null;

  return (
    <>
      <div className="content__header">
        <div>
          <h1 className="content__title">{t('biometricData.title')}</h1>
        </div>
      </div>
      <div className="content__body">
        <BiometricDataView canWrite={canWrite} />
      </div>
    </>
  );
}
